import * as Sentry from "@sentry/vue";
import { i18nVue } from "laravel-vue-i18n";
import axios from "axios";

require("./bootstrap");
require("../argon/js/argon-dashboard");
require("./components/review-preorder");

import { createApp } from "vue";

import CartComponent from "./components/CartComponent.vue";

const app = createApp({});

if (process.env.MIX_SENTRY_DSN) {
    Sentry.init({
        app,
        dsn: process.env.MIX_SENTRY_DSN,
        environment: process.env.NODE_ENV || "development",
        maxBreadcrumbs: 10,
        enabled: process.env.NODE_ENV === "production",
    });

    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            Sentry.captureException(error, {
                tags: {
                    api_url: error.config?.url,
                    api_method: error.config?.method,
                },
                extra: {
                    status: error.response?.status,
                    response_data: error.response?.data,
                },
            });
            return Promise.reject(error);
        }
    );
}

app.use(i18nVue, {
    resolve: (lang: string) => import(`../lang/${lang}.json`),
    fallbackLocale: 'en',
})
    .component("cart", CartComponent)
    .mount("#app");
